// extracted by mini-css-extract-plugin
module.exports = {"content":"ResetTwoFa_content__38LE_","row":"ResetTwoFa_row__1-qom","button":"ResetTwoFa_button__aCKm5","submit":"ResetTwoFa_submit__3yGog"};